module.exports = __webpack_public_path__ + "static/img/8-22.f95a7bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/newsDetail/8-22.png
// module id = ujG+
// module chunks = 1